export function parseHTML(htmlString, linkPrefix = "") {
  if (!htmlString || typeof htmlString !== "string") {
    return htmlString;
  }
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  
  // Aktualisiere alle <a>-Tags, deren href relativ ist
  const links = doc.body.querySelectorAll("a");
  links.forEach((link) => {
    const href = link.getAttribute("href");
    if (href && !href.match(/^https?:\/\//i) && !href.startsWith("mailto:") && !href.startsWith("tel:")) {
      // Falls der Link noch nicht mit dem Prefix beginnt, füge ihn hinzu
      if (!href.startsWith(linkPrefix)) {
        link.setAttribute("href", linkPrefix + "/" + href);
      }
    }
  });
  return { __html: doc.body.innerHTML || "" };
}
